import { QueueType } from "@redotech/redo-model/marketing/marketing-conversation/marketing-conversation-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getQueueCount = {
  name: "getQueueCount" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    queueType: createEnum(QueueType).default(QueueType.Default).optional(),
  }),
  output: z.object({ count: z.number() }),
};
